import React from "react";
import { QRCodeSVG } from "qrcode.react";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.solo_connect.app";
const APP_STORE_URL =
  "https://apps.apple.com/in/app/soloconnect-travel-meet/id6753793984";

export default function DownloadBanner() {
  return (
    <section className="py-8 md:py-12 bg-[#F8F7FD]">
      <div className="max-w-6xl mx-auto ">
        <div
          className="relative rounded-[2rem] overflow-visible "
          style={{ minHeight: "220px" }}
          data-aos="fade-up"
          data-aos-duration="800"
        >
          {/* ── Background SVG ── */}
          <div className="absolute inset-0 rounded-[2rem] overflow-hidden">
            <img
              src="/img/home/phonebg.svg"
              alt=""
              className="hidden md:block w-full h-full object-cover object-center"
              aria-hidden="true"
            />
            <img
              src="/img/home/phonebg1.svg"
              alt=""
              className="block md:hidden w-full h-full object-cover object-center"
              aria-hidden="true"
            />
          </div>

          {/* ── Overlay tint for readability ── */}
          <div className="absolute inset-0 bg-white/10" aria-hidden="true" />

          {/* ── MAIN CONTENT ROW ── */}
          <div className="relative z-10 flex justify-center items-center  gap-14">

            {/* ── DESKTOP VIEW (Hidden on Mobile) ── */}
            <div
              className="hidden md:flex flex-shrink-0 justify-center relative"
              data-aos="fade-right"
              data-aos-delay="150"
              data-aos-duration="800"
            >
              <div>
                <img
                  src="/img/home/phone13.svg"
                  alt="SoloConnect App"
                  className="drop-shadow-2xl h-0 md:h-[300px] lg:h-[400px] xl:h-[500px] 2xl:h-[600px] object-contain"
                />
              </div>

              <div
                className="flex-1 flex flex-col justify-center text-center md:text-left px-6 md:px-8 lg:px-10 py-8 md:py-10"
                data-aos="fade-up"
                data-aos-delay="250"
                data-aos-duration="800"
              >
                {/* Italic sub-heading */}
                <p
                  className="text-purple-600 font-semibold mb-1 text-base sm:text-lg"
                  style={{ fontStyle: "italic", fontFamily: "Georgia, serif" }}
                >
                  Your Next Adventure
                </p>

                {/* Main heading */}
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold leading-tight text-slate-900 mb-3">
                  Starts with a{" "}
                  <span
                    style={{
                      background: "linear-gradient(90deg, #7209B7 0%, #7F1AA6 9.32%, #FFBF00 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    Connection
                  </span>
                </h2>

                {/* Description */}
                <p className="text-sm text-slate-600 max-w-xl mx-auto md:mx-0 leading-relaxed mb-6">
                  SoloConnect brings solo travelers together. Meet like minded
                  people, explore new places, and create unforgettable memories
                </p>

                {/* Download Now + Store badges + QR */}
                <div className="flex flex-col items-center gap-6 md:flex-row md:items-center md:gap-4">
                  <div className="flex flex-col items-center md:items-start">
                    <a
                      href={PLAY_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-3 bg-[#7209B7] hover:bg-[#5f0799] text-white font-bold text-lg md:text-sm px-10 py-2.5 rounded-full shadow-lg transition-all duration-300 hover:scale-105 active:scale-95"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-5 h-5"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" x2="12" y1="15" y2="3" />
                      </svg>
                      Download Now
                    </a>
                    <div className="flex items-center gap-4 mt-4">
                      <a
                        href={PLAY_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:scale-105 transition-transform duration-200"
                      >
                        <img
                          src="/img/home/play-store-btn.svg"
                          alt="Get it on Google Play"
                          className="h-9"
                        />
                      </a>
                      <a
                        href={APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:scale-105 transition-transform duration-200"
                      >
                        <img
                          src="/img/home/app-store-btn.svg"
                          alt="Download on the App Store"
                          className="h-9"
                        />
                      </a>
                    </div>
                  </div>

                  <div className="bg-white p-2 rounded-sm">
                    <QRCodeSVG
                      className="pl-2"
                      value={PLAY_STORE_URL}
                      size={100}
                      bgColor="#ffffff"
                      fgColor="#1a0533"
                      level="H"
                    />
                    <p className="text-[12px] text-black">Scan to Download</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ── MOBILE VIEW (Hidden on Desktop) ── */}
            <div
              className="flex md:hidden flex-shrink-0 w-full flex-col-reverse justify-center items-center relative"
              data-aos="fade-right"
              data-aos-delay="150"
              data-aos-duration="800"
            >
              <div className="w-full flex justify-center mt-6 z-10 relative">
                <img
                  src="/img/home/phone131.svg"
                  alt="SoloConnect App Mobile"
                  className="drop-shadow-2xl h-[450px] sm:h-[550px] object-contain"
                />
              </div>

              <div
                className="flex-1 w-full flex flex-col justify-center text-center px-6 sm:px-8 pt-10 z-20"
                data-aos="fade-up"
                data-aos-delay="250"
                data-aos-duration="800"
              >
                {/* Italic sub-heading */}
                <p
                  className="text-purple-600 font-semibold mb-1 text-base sm:text-lg"
                  style={{ fontStyle: "italic", fontFamily: "Georgia, serif" }}
                >
                  Your Next Adventure
                </p>

                {/* Main heading */}
                <h2 className="text-2xl sm:text-3xl font-extrabold leading-tight text-slate-900 mb-3">
                  Starts with a{" "}
                  <span
                    style={{
                      background: "linear-gradient(90deg, #7209B7 0%, #7F1AA6 9.32%, #FFBF00 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    Connection
                  </span>
                </h2>

                {/* Description */}
                <p className="text-sm text-slate-600 max-w-xl mx-auto leading-relaxed mb-6">
                  SoloConnect brings solo travelers together. Meet like minded
                  people, explore new places, and create unforgettable memories
                </p>

                {/* Download Now + Store badges + QR */}
                <div className="flex flex-col items-center gap-10 mt-4">
                  <div className="flex flex-col items-center gap-5">
                    <a
                      href={PLAY_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-3 bg-[#7209B7] hover:bg-[#5f0799] text-white font-bold text-base px-8 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105 active:scale-95"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-5 h-5"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" x2="12" y1="15" y2="3" />
                      </svg>
                      Download Now
                    </a>
                    <div className="flex items-center gap-4">
                      <a
                        href={PLAY_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:scale-105 transition-transform duration-200"
                      >
                        <img
                          src="/img/home/play-store-btn.svg"
                          alt="Get it on Google Play"
                          className="h-10"
                        />
                      </a>
                      <a
                        href={APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:scale-105 transition-transform duration-200"
                      >
                        <img
                          src="/img/home/app-store-btn.svg"
                          alt="Download on the App Store"
                          className="h-10"
                        />
                      </a>
                    </div>
                  </div>

                  <div className="flex flex-col items-center mt-2">
                    <div className="relative p-3 inline-block ">
                      {/* Corners */}
                      <div className="absolute top-0 left-0 w-6 h-6 border-t-[2px] border-l-[2px] border-purple-600 rounded-tl-xl"></div>
                      <div className="absolute top-0 right-0 w-6 h-6 border-t-[2px] border-r-[2px] border-purple-600 rounded-tr-xl"></div>
                      <div className="absolute bottom-0 left-0 w-6 h-6 border-b-[2px] border-l-[2px] border-purple-600 rounded-bl-xl"></div>
                      <div className="absolute bottom-0 right-0 w-6 h-6 border-b-[2px] border-r-[2px] border-purple-600 rounded-br-xl"></div>
                      
                      <div className="bg-white p-2 rounded-xl">
                        <QRCodeSVG
                          value={PLAY_STORE_URL}
                          size={100}
                          bgColor="#ffffff"
                          fgColor="#1a0533"
                          level="H"
                          className="mx-auto"
                        />
                      </div>
                    </div>
                    <p
                      className="text-purple-600 font-semibold mt-3 text-base sm:text-lg"
                      style={{ fontStyle: "italic", fontFamily: "Georgia, serif" }}
                    >
                      Scan to Download
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* ── CENTER: Text + Buttons ── */}
          

          </div>
        </div>
      </div>
    </section>
  );
}